import { createFileRoute } from '@tanstack/react-router'
// eslint-disable-next-line import/no-unresolved
import Connect from '@ui/components/connect'
// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/no-unresolved
import Header from '@ui/components/header'
// eslint-disable-next-line import/no-unresolved
import Partners from '@ui/components/partners'
import { z } from 'zod'

import ProjectTabs from '../components/tabs/project'

const projectSearchSchema = z.object({
  id: z.coerce.number().optional()
})

export const Route = createFileRoute('/project')({
  validateSearch: projectSearchSchema,
  component: () => {
    return (
      <div className="w-full flex flex-col">
        <Header />
        <ProjectTabs />
        <Partners />
        <Connect />
      </div>
    )
  }
})
